import React from "react"
import SearchBarWithStoreWithData from "../SearchBar/SearchBarWithStoreWithData"
import PropTypes from "prop-types"
import "./SearchPage.scss"

class SearchPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      searchMode: false,
    }
  }

  toggleSearchMode = () => {
    this.setState({ searchMode: !this.state.searchMode })
  }

  render() {
    return (
      <div
        className={
          this.state.searchMode ? "SearchPage search-mode" : "SearchPage"
        }
      >
        <div
          className="gray-background"
          onClick={this.state.searchMode ? this.toggleSearchMode : null}
        />
        <div className="background-image" />
        <img
          className="logo"
          src="/icons/ATLogo.svg"
          alt={"AssetTracking Logo"}
        />
        <h1>Asset Locator</h1>
        <SearchBarWithStoreWithData
          searchMode={this.state.searchMode}
          onSearchMode={this.toggleSearchMode}
          searchOnEmptyInput={false}
          {...this.props}
        />
      </div>
    )
  }
}

SearchPage.propTypes = {
  facilityId: PropTypes.string.isRequired,
  redirect: PropTypes.func.isRequired,
}

export default SearchPage
